import { WaitTimeResponseInfo, Device } from '../../../models/apiModels';
import { RequestModality } from './requestModels';

export enum WaitTimeResponseReason {
  // No reason
  None = 0,

  // Out of business hours for non-english language support
  OutOfBusinessHours = 1,

  // Out of business hours for a specialist support
  SpecialistOutOfBusinessHours = 2
}

export class WaitTimeResponseModel {
  // Gets or sets support modality
  public Modality: RequestModality;

  // Gets or sets support area name
  public SupportAreaName: string;

  // Gets or sets estimated wait time
  public WaitTime: number;

  // Gets or sets special reason if any applied for wait time calculation
  public Reason: WaitTimeResponseReason;

  // Gets or sets the information that help the client to understand the wait time calculation
  public Info: WaitTimeResponseInfo;

  // Gets or sets the available time slots
  public TimeSlots: Array<string>;
}

export class AgentModalities {
  // List of agent modalities
  public Modalities: Array<WaitTimeResponseModel>;
}

export class NonAgentModality {
  // Id
  public Id: string;

  // Title
  public Title: string;

  // Description
  public Description: string;

  // Link
  public Link: string;

  // NonAgentModalityType
  public Type: NonAgentModalityType;
}

export class NonAgentModalities {
  // List of non-agent modalities
  public Modalities: Array<NonAgentModality>;
}

export enum RegionType {
  // Country is neither placeholder or top region.
  None = 0,

  // Country is placeholder.
  PlaceHolder = 1,

  // Country is top region.
  TopRegions = 2
}

export class Region {
  public DialingCode: string;
  public Name: string;
  public RegionType: RegionType;
  public TwoDigitCountryCode: string;
}

export class ModalityResponseModel {
  // Agent modalities
  public AgentModalities: AgentModalities;

  // Non-agent modalities
  public NonAgentModalities: NonAgentModalities;

  // RegionInfo
  public RegionInfo: Array<Region>;

  // List of devices running with outdated Windows
  public OutdatedWindowsDevices?: Array<Device>;

  // ShowAskCommunity
  public ShowAskCommunity: boolean;

  // Indicates if modality response came from DfC
  public IsDfC: boolean;
}

export enum NonAgentModalityType {
  Standard = 0,
  Promotion = 1,
  Recommendation = 2,
  DescriptionOnly = 3,
  OEM = 4,
  RedirectURL = 5,
  AMCAskCommunity =6
}

export class TimeZoneInfo {
  // Time Zone displayname
  public DisplayName!: string;

  // Time zone Id
  public Id!: string;

  // The number of hours a certain time zone is ahead of or behind GM
  public Offset!: string;

  // Time zone standardname
  public StandardName!: string;
}

export class SupportedLanguage {
  // Culture identifier
  public LCID!: number;

  // Support language name
  public Name!: string;

  // Support language native name
  public NativeName!: string;
}
